var _polyline, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
var SvgPSignalStorageTimeControl = function SvgPSignalStorageTimeControl(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    x: "0px",
    y: "0px",
    viewBox: "0 0 684.2 480.2",
    xmlSpace: "preserve",
    enableBackground: "new 0 0 684.2 480.2"
  }, props), _polyline || (_polyline = /*#__PURE__*/React.createElement("polyline", {
    points: "312.1,380.1 350.1,380.1 349.1,380.1 349.1,237.2 304.1,237.2 304.1,237.1 304.1,55.1 342.1,55.1 342.1,46.1",
    fill: "none",
    stroke: "#1C9D5B",
    strokeWidth: 2,
    strokeMiterlimit: 10
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M349.3,300.6c-5.8,0-10.5-4.7-10.5-10.5s4.7-10.5,10.5-10.5s10.5,4.7,10.5,10.5S355.1,300.6,349.3,300.6z",
    fill: "#FFFFFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,280.1c5.5,0,10,4.5,10,10s-4.5,10-10,10s-10-4.5-10-10S343.8,280.1,349.3,280.1 M349.3,279.1 c-6.1,0-11,4.9-11,11s4.9,11,11,11s11-4.9,11-11S355.4,279.1,349.3,279.1L349.3,279.1z",
    fill: "#1C9D5B"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M349.3,283.2c3.8,0,6.9,3.1,6.9,6.9s-3.1,6.9-6.9,6.9s-6.9-3.1-6.9-6.9S345.6,283.2,349.3,283.2 M349.3,282.2 c-4.3,0-7.9,3.5-7.9,7.9s3.5,7.9,7.9,7.9s7.9-3.5,7.9-7.9S353.7,282.2,349.3,282.2L349.3,282.2z"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 349.3,
    cy: 290.1,
    r: 0.8
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.3,
    y1: 290.1,
    x2: 349.3,
    y2: 285.4,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("line", {
    x1: 349.3,
    y1: 290.1,
    x2: 352.4,
    y2: 293.7,
    fill: "none",
    stroke: "#000000",
    strokeMiterlimit: 10
  }))));
};
export default SvgPSignalStorageTimeControl;